export default __webpack_public_path__ + "static/media/logo-ijc.c78752cc.png";